// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-dropdown-root.MuiList-root.MuiPaper-root {
    display: flex;
    padding: var(--borderRadius, 4px) 0px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 8px;
    background: var(--Conditional-pop-over, #fff);
  }
  
  .setting-dropdown-header {
    display: flex;
    align-items: center;
    padding: 5px 12px;
    gap: 8px;
  }
  
  .setting-dropdown-header-typography.MuiTypography-root {
    color: var(--character-title-85, rgba(0, 0, 0, 0.85));
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.02px;
  }
  
  .setting-dropdown-item-conatiner {
    display: flex;
    justify-content: space-between;
    padding: 5px 16px;
    gap: 12px;
    flex-direction: column;
  }
  
  .setting-dropdown-item-typography.MuiTypography-root {
    color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  
    /* Medium/14 */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.05px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/customDropdownList/customDropdownList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,qDAAqD;IACrD,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,qDAAqD;;IAErD,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,uBAAuB;EACzB","sourcesContent":[".settings-dropdown-root.MuiList-root.MuiPaper-root {\n    display: flex;\n    padding: var(--borderRadius, 4px) 0px;\n    flex-direction: column;\n    align-items: flex-start;\n    border-radius: 8px;\n    background: var(--Conditional-pop-over, #fff);\n  }\n  \n  .setting-dropdown-header {\n    display: flex;\n    align-items: center;\n    padding: 5px 12px;\n    gap: 8px;\n  }\n  \n  .setting-dropdown-header-typography.MuiTypography-root {\n    color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px; /* 142.857% */\n    letter-spacing: -0.02px;\n  }\n  \n  .setting-dropdown-item-conatiner {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 16px;\n    gap: 12px;\n    flex-direction: column;\n  }\n  \n  .setting-dropdown-item-typography.MuiTypography-root {\n    color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n  \n    /* Medium/14 */\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    letter-spacing: -0.05px;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
